import DocumentQuestionnaire from './document-questionnaire';

export default DocumentQuestionnaire;
